<template>
</template>
<script>
export default {
  props: {
    paperInfo: Object,
    blockInfo: Object,
    boardMemberInfo: Object,
    boardSection: Array,
    bdata: Object,
    transmitter: Object,
    userInfo: Object,
    paperBlockIdList: Array,
    paperBlockMap: Object,
    boardUtil: Object,
    context: Object,
    memberSelector: Object,
  },
  data() {
      return { }
  },
  created() {
    this.context.initContentBlock(this);
  },
  mounted() { },
  methods: {
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/board/editor/ContentBlockTypeNull.vue